var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarForest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2702 16.6667H13.9368V13.3333H17.2702V16.6667ZM12.2702 8.33333H8.93685V11.6667H12.2702V8.33333ZM17.2702 8.33333H13.9368V11.6667H17.2702V8.33333ZM7.27018 13.3333H3.93685V16.6667H7.27018V13.3333ZM12.2702 13.3333H8.93685V16.6667H12.2702V13.3333ZM7.27018 8.33333H3.93685V11.6667H7.27018V8.33333ZM20.6035 1.66667V20H0.603516V1.66667H3.10352V2.5C3.10352 3.41917 3.85102 4.16667 4.77018 4.16667C5.68935 4.16667 6.43685 3.41917 6.43685 2.5V1.66667H14.7702V2.5C14.7702 3.41917 15.5177 4.16667 16.4368 4.16667C17.356 4.16667 18.1035 3.41917 18.1035 2.5V1.66667H20.6035ZM18.9368 6.66667H2.27018V18.3333H18.9368V6.66667ZM17.2702 0.833333C17.2702 0.373333 16.8977 0 16.4368 0C15.976 0 15.6035 0.373333 15.6035 0.833333V2.5C15.6035 2.96 15.976 3.33333 16.4368 3.33333C16.8977 3.33333 17.2702 2.96 17.2702 2.5V0.833333ZM5.60352 2.5C5.60352 2.96 5.23102 3.33333 4.77018 3.33333C4.30935 3.33333 3.93685 2.96 3.93685 2.5V0.833333C3.93685 0.373333 4.30935 0 4.77018 0C5.23102 0 5.60352 0.373333 5.60352 0.833333V2.5Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarForest);
export default __webpack_public_path__ + "static/media/calendar-forest.fa057c121bf53122fc4d7a18e26800fa.svg";
export { ForwardRef as ReactComponent };